import React from 'react';
import { useTranslation } from "react-i18next"; 
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'; 
import Button from '@mui/material/Button'; 
import Card from '@mui/material/Card'; 
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import SettingsIcon from '@mui/icons-material/Settings';
import Typography from '@mui/material/Typography'; 
import 'react-toastify/dist/ReactToastify.css'  
import "css/generalSettings.css";
import "css/customDialog.css";
import "css/homeDashboardBlue.css";
import "css/shippingListResponsive.css";
import PropTypes from 'prop-types';
import image1 from "components/photos/sidebars/sheet.png"; 
import image2 from "components/photos/sidebars/endsheet.png"; 
import image3 from "components/photos/sidebars/reviewsheet.png"; 
import image4 from "components/photos/form.jpg";
import image5 from "components/photos/finishedform.jpg";
import image6 from "components/photos/endform.jpg";  
import image7 from "components/photos/sidebars/portill.jpeg";  
import image8 from "components/photos/sidebars/portbillended.jpeg"; 
import image9 from "components/photos/sidebars/notificactions.jpeg";
import image10 from "components/photos/sidebars/notifiactionsview.jpeg";
import image11 from "components/photos/contract.jpg"; 
import image12 from "components/photos/sidebars/resolution.png";   
import image13 from "components/photos/sidebars/aricles.jpg"; 
import image14 from "components/photos/purchase.png"; 
import image15 from "components/photos/purchaseended.jpeg"; 
import image16 from "components/photos/sidebars/shippingpending.jpeg";

const data = [{
  "id": 1,
  "title": "Text_TITLE_CREATE_SHEET",
  "information":"Text_INFORMATION_CREATE_SHEET",
  "icon":image1,
  "isEnabled":true
 
},{
  "id": 2,
  "title": "Text_TITLE_CREATE_SHEET_ENDED",
  "information":"Text_INFORMATION_CREATE_SHEET_ENDED",
  "icon":image2,
  "isEnabled":true
 
},{
  "id": 3,
  "title": "Text_TITLE_CREATE_SHEET_MODIFIED",
  "information":"Text_INFORMATION_CREATE_SHEET_MODIFIED",
  "icon":image3,
  "isEnabled":true
},{
  "id": 4,
  "title": "Text_TITLE_CREATE_FORM",
  "information":"Text_INFORMATION_CREATE_FORM",
  "icon":image4,
  "isEnabled":true
 
},{
  "id": 5,
  "title": "Text_TITLE_FINISHED_FORM",
  "information":"Text_INFORMATION_FINISHED_FORM",
  "icon":image5,
  "isEnabled":true
},{
  "id": 6,
  "title": "Text_TITLE_MODIFIED_FORM",
  "information":"Text_INFORMATION_MODIFIED_FORM",
  "icon":image6,
  "isEnabled":true
},{
  "id": 7,
  "title": "Text_TITLE_CREATE_ARTICLES",
  "information":"Text_INFORMATION_CREATE_ARTCICLES",
  "icon":image13,
  "isEnabled":true 
},{
  "id": 8,
  "title": "Text_TITLE_CREATE_NOTIFICATIONS",
  "information":"Text_INFORMATION_CREATE_NOTIFICATIONS",
  "icon":image9,
  "isEnabled":true
},{
  "id": 9,
  "title": "Text_TITLE_MODIFIED_NOTIFICATIONS",
  "information":"Text_INFORMATION_MODIFIEDNOTIFICATIONS",
  "icon":image10,
  "isEnabled":true
},{
  "id": 10,
  "title": "Text_TITLE_CREATE_SHIPPING",
  "information":"Text_INFORMATION_CREATE_SHIPPING",
  "icon":image7,
  "isEnabled":true
},{
  "id": 11,
  "title": "Text_TITLE_MODIFIED_SHIPPING",
  "information":"Text_INFORMATION_MODIFIEDSHIPPING",
  "icon":image16,
  "isEnabled":true
},{
  "id": 12,
  "title": "Text_TITLE_MODIFIED_SHIPPING_ENDED",
  "information":"Text_INFORMATION_MODIFIEDSHIPPING_ENDED",
  "icon":image8,
  "isEnabled":true
}
,{
  "id": 13,
  "title": "Text_TITLE_CREATE_PURCHASES_IN",
  "information":"Text_INFORMATION_CREATE_PURCHASES_IN",
  "icon":image14,
  "isEnabled":true
 
},{
  "id": 14,
  "title": "Text_TITLE_CREATE_PURCHASES_OUT",
  "information":"Text_INFORMATION_CREATE_PURCHASES_OUR",
  "icon":image15,
  "isEnabled":true
 
},{
  "id": 15,
  "title": "Text_TITLE_MODIFIED_CONTRACT",
  "information":"Text_INFORMATIONCONTRACT",
  "icon":image11,
  "isEnabled":true
},{
  "id": 16,
  "title": "Text_TITLE_CREATE_INCIDENTS",
  "information":"Text_INFORMATIONINCIDENTS",
  "icon":image12,
  "isEnabled":true
}]

const PrincipalMenuSettings = ({ 
  showPrincipalMenu 
}) => {

  const {t} = useTranslation(['listDataGeneralSettings']); 
  const roles = useSelector((state) => state.loginUser.roles); 

  data[0].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Sheet'))?true:false;
  data[1].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Sheet_Ended'))?true:false;
  data[2].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Sheet_Edit_Ended'))?true:false;
  data[3].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_Create'))?true:false;
  data[4].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_Edit'))?true:false;
  data[5].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_Edit_Ended'))?true:false;
  data[6].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Articles_View_Init'))?true:false;
  data[7].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_NT_View_Init'))?true:false;
  data[8].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_NT_View_Ended_Init'))?true:false;
  data[9].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Shipping_View_Init'))?true:false;
  data[10].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Shipping_View_Pending_Init'))?true:false;
  data[11].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Shipping_View_Ended_Init'))?true:false;
  data[12].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Purchases'))?true:false;
  data[13].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Purchases'))?true:false;
  data[14].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Contract_View_Init'))?true:false;
  data[15].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Incident_Create'))?true:false;

  const navigate = useNavigate();

  const closeModal = (id) => {
    switch (id) {
      case 1:    
        navigate("/sheetdetail/0");  
        break;
      case 2:    
        navigate("/sheet");  
        break;
      case 3:    
        navigate("/sheetended");  
        break;
      case 4:    
        navigate("/formdetail/0");  
        break;
      case 5:    
        navigate("/formdi");  
        break;
      case 6:    
        navigate("/formdiended");  
        break;
      case 7:    
        navigate("/article");  
        break;
      case 8:    
        navigate("/ntdetailhome/0");  
        break;
      case 9:    
        navigate("/nthome");  
        break;
      case 10:    
        navigate("/shippingdetailhome/0");  
        break;
      case 11:    
        navigate("/shipping");  
        break;
      case 12:    
        navigate("/shippingended");  
        break;
      case 13:    
        navigate("/purchasedeliveryin");  
        break;
      case 14:    
        navigate("/purchasedeliveryout");  
        break;
      case 15:    
        navigate("/contract");  
        break;
      case 16:    
        navigate("/sentincidentemail/0");  
        break;
      default:
        break;
    } 
  };

  return (
    <>
      {showPrincipalMenu ? (     
        //* Begin Page Content *//
       <div className="main-dashboard-container">
          {/* Search input */}
          <h1 className="dashboard-title">
            <SettingsIcon /> {t('Text_MENU_PRINCIPAL')}
          </h1>        
          <Grid container spacing={4} className="dashboard-grid">
            {data.map((post) => (
              post.isEnabled && (
                <Grid item xs={12} sm={6} md={4} key={post.id}>
                  <Card className={`menu-card ${[10, 11, 12].includes(post.id) ? "shipping-menu-card" : ""}`} onClick={() => closeModal(post.id)}>
                    <CardMedia image={post.icon} title={t(post.title)} />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div" align="center">
                        {t(post.title)}
                      </Typography>
                      <Typography variant="body2" align="center">
                        {t(post.information)}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "center" }}>
                      <Button>{t('Text_Select')}</Button>
                    </CardActions>
                  </Card>
                </Grid>
              )
            ))}
          </Grid>
        </div> 
        //* End Page Content *//
      ) :  null }
    </>
  );
};

PrincipalMenuSettings.propTypes = { 
  showPrincipalMenu: PropTypes.bool.isRequired
};

export default PrincipalMenuSettings;
